import React from 'react';
import PropTypes from 'prop-types';
import { resolveImageUrl } from 'utils/apiOrigin';

export default function ThumbImage({ src, alt = '', size = 100, radius = 8 }) {
  const url = resolveImageUrl(src);
  if (!url) return null;

  return (
    <img
      src={url}
      alt={alt}
      width={size}
      height={size}
      loading="lazy"
      style={{ objectFit: 'contain', borderRadius: radius }}
      onError={(e) => {
        e.currentTarget.style.visibility = 'hidden';
      }}
    />
  );
}

ThumbImage.propTypes = {
  src: PropTypes.string.isRequired,
  alt: PropTypes.string,
  size: PropTypes.number,
  radius: PropTypes.number,
};
